import { TextBox } from "devextreme-react";
import { RequiredRule } from "devextreme-react/form";
import React, { useEffect } from "react";

export default function TwoTextBoxComponent(props) {
  const { firstTextBox, secondTextBox, setFormDataSource } = props;

  const onFirstValueChanged = (e) => {
    setFormDataSource((prevState) => ({
      ...prevState,
      [firstTextBox.field]: e.value,
    }));
  };

  const onSecondValueChanged = (e) => {
    setFormDataSource((prevState) => ({
      ...prevState,
      [secondTextBox.field]: e.value,
    }));
  };

  return (
    <React.Fragment>
      <TextBox
        style={{
          float: "left",
          width: "49%",
          marginRight: "3px",
        }}
        placeholder={firstTextBox.placeholder}
        showClearButton={true}
        value={firstTextBox.value}
        validationStatus={
          firstTextBox.requiredRuleMessage
            ? firstTextBox.value
              ? "valid"
              : "invalid"
            : "valid"
        }
        onValueChanged={onFirstValueChanged}
      >
        {firstTextBox.requiredRuleMessage && (
          <RequiredRule message={firstTextBox.requiredRuleMessage} />
        )}
      </TextBox>
      <TextBox
        style={{
          float: "left",
          width: "49%",
        }}
        placeholder={secondTextBox.placeholder}
        showClearButton={true}
        value={secondTextBox.value}
        validationStatus={
          secondTextBox.requiredRuleMessage
            ? secondTextBox.value
              ? "valid"
              : "invalid"
            : "valid"
        }
        onValueChanged={onSecondValueChanged}
      >
        {secondTextBox.requiredRuleMessage && (
          <RequiredRule message={secondTextBox.requiredRuleMessage} />
        )}
      </TextBox>
    </React.Fragment>
  );
}
